import { render } from "./NewAdress.vue?vue&type=template&id=589f0ebf"
import script from "./NewAdress.vue?vue&type=script&lang=js"
export * from "./NewAdress.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__